module.exports = __webpack_public_path__ + "static/img/img.a0592c19.png";